/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Section_VisibilityInputs */



/**
* | output |
* | --- |
* | "Visibility" |
*
* @param {Tfield_Section_VisibilityInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_section_visibility = /** @type {((inputs?: Tfield_Section_VisibilityInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Section_VisibilityInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Visibilité")
	if (locale === "es") return /** @type {LocalizedString} */ ("Visibilidad")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Visibilidade")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visibilità")
	return /** @type {LocalizedString} */ ("Visibility")
});